
import {
    INIT,
    RESET,
    SET_DIAS,
    SET_DISABLED,
    SET_TIPO_GESTION,
   
} from './types';

export const initialStateDisabled={
    "siniestro":{disabled:false, radio:true},
    "patente": {disabled:false, radio:true},
    "idcaso": {disabled:false, radio:true},  
    "tarea": {disabled:false, radio:true},    
    "estadocaso": {disabled:false, radio:false},    
    "fechadesde": {disabled:false, radio:false},
    "fechahasta": {disabled:false, radio:false}, 
    "tipofecha": {disabled:false, radio:false}, 
    "companias": {disabled:false, radio:false}, 
    "sitDePendiente": {disabled:false, radio:false}
    //RG-536 se eliminan respuestacia (Evaluación CIA) y motivorpta (Estado Evaluación CIA)
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},                              
                tarea:{...state.tarea, disabled:false},
                estadocaso:{...state.estadocaso, disabled:false},              
                idcaso:{...state.idcaso, disabled:false},              
                fechadesde:{...state.fechadesde, disabled:false},
                fechahasta:{...state.fechahasta, disabled:false},
                tipofecha:{...state.tipofecha, disabled:false},
                companias:{...state.companias, disabled:true},
                sitDePendiente:{...state.sitDePendiente, disabled:true}
                }
        case INIT:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},                             
                tarea:{...state.tarea, disabled:false},
                estadocaso:{...state.estadocaso, disabled:false},              
                idcaso:{...state.idcaso, disabled:false},               
                fechadesde:{...state.fechadesde, disabled:true},
                fechahasta:{...state.fechahasta, disabled:true},
                tipofecha:{...state.tipofecha, disabled:true},
                companias:{...state.companias, disabled:true},
                sitDePendiente:{...state.sitDePendiente, disabled:true}
                }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }        
        
        case SET_DIAS:
            return { ...state, dias:{...state.dias, disabled:action.payload}}
     
        
        
       
       
        default:
            return state
    }
}